import Flex from 'UIKit/Box/Flex'
import Grid from 'UIKit/Box/Grid'
import Text from 'UIKit/Text'
import styled, { css } from 'styled-components'

const sharedLanguagePopupStyles = css`
  --option-radius: ${({ theme }) => theme.radii.button};
  --option-container-padding: 8px;
  --option-container-radius: calc(var(--option-radius) + var(--option-container-padding));
`

const StyledLanguagePopupContainer = styled(Grid)`
  ${sharedLanguagePopupStyles}

  background-color: ${({ theme }) => theme.colors.bg_surface};
  border-radius: var(--option-container-radius);
  padding: var(--option-container-padding);
  border: 1px solid ${({ theme: { colors } }) => colors.buttonBackgroundAlt2};
`

const StyledLanguageItem = styled(Flex)`
  ${sharedLanguagePopupStyles}

  align-items: center;
  border-radius: var(--option-radius);
  padding: 6px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.card_primary_active_alt};

    ${Text} {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`

const StyledLangugeSelected = styled(Flex)<{ $Small?: boolean }>`
  width: 68px;
  height: 36px;
  padding: 10px 8px;
  border-radius: ${({ theme: { radii } }) => radii.button};
  background: ${({ theme: { colors } }) => colors.card_primary};
`

export { StyledLanguageItem, StyledLanguagePopupContainer, StyledLangugeSelected }
